import HireXLModal from './Modal.react'

export default HireXLModal
